import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from 'utils/i18n';
import { sanitize } from 'utils/validation';
import { GLOBAL } from 'constants';

const LimitedInventoryADABanner = ({ hasADAExtra, extras, isVehicleLimitedInventory, name }) => {
  const adaptiveEquipmentExtras = extras
    ?.filter((extra) => extra.adaptive_equipment === true)
    .map((extra) => extra.name);

  const limitedInventoryItems = extras
    ?.filter((extra) => extra.allocation === GLOBAL.LIMITED_INVENTORY_EXTRA_CODE && !extra.adaptive_equipment)
    .map((extra) => extra.name);

  if (isVehicleLimitedInventory && name) {
    limitedInventoryItems.push(name);
  }

  const uniqueLimitedInventoryExtras = limitedInventoryItems?.length;

  const formatList = (items) => {
    const itemsLength = items?.length;

    if (!items || itemsLength === 0) {
      return '';
    }

    const strong = (text) => `<strong>${text}</strong>`;

    if (itemsLength === 1) {
      return strong(items[0]);
    }

    const andSeparator = i18n('and');

    if (itemsLength === 2) {
      return `${strong(items[0])} ${andSeparator} ${strong(items[1])}`;
    }

    const lastItem = items[itemsLength - 1];
    const otherItems = items.slice(0, itemsLength - 1).join(', ');
    return `${strong(otherItems)} ${andSeparator} ${strong(lastItem)}`;
  };

  const getHeaderText = () => {
    if (hasADAExtra && uniqueLimitedInventoryExtras) {
      return i18n('you_selected_ada_and_limited_inventory_items');
    }

    if (hasADAExtra) {
      return i18n('you_selected_ada_item');
    }

    return i18n('you_selected_limited_inventory_item');
  };

  const getEquipmentText = () => {
    const adaptiveEquipmentText = formatList(adaptiveEquipmentExtras);
    const limitedInventoryText = formatList(limitedInventoryItems);

    if (hasADAExtra && uniqueLimitedInventoryExtras) {
      return `${adaptiveEquipmentText} ${i18n('and')} ${limitedInventoryText}`;
    }

    if (hasADAExtra) {
      return adaptiveEquipmentText;
    }

    return limitedInventoryText;
  };

  return (
    <div className='rental-details__card rental-details__limited-inventory-container'>
      <div className='icon-alert limited-inventory'>
        <span></span>
      </div>

      <div>
        <div className='rental-details__limited-inventory-header'>{getHeaderText()}</div>
        <div
          dangerouslySetInnerHTML={sanitize(
            i18n('you_will_be_contacted_to_confirm_selection_reservation', { 0: getEquipmentText() })
          )}
        />
      </div>
    </div>
  );
};

LimitedInventoryADABanner.propTypes = {
  hasADAExtra: PropTypes.bool,
  extras: PropTypes.array,
  isVehicleLimitedInventory: PropTypes.bool,
  name: PropTypes.string,
};

export default LimitedInventoryADABanner;
